<template>
    <div class="d-flex justify-center align-center pb-4">
        <v-card class="form-card" v-if="redirectCredentials">
            <h1 class="justify-center">{{ $t('credentialsWithEmail') }}</h1>
            <div class="d-flex justify-center py-4">
                <v-alert type="error" v-if="error">
                    {{ error }}
                </v-alert>
            </div>
            <v-form ref="form" v-model="valid">
                <div class="row-content mx-auto">
                    <v-text-field
                            name="password"
                            :label="$t('pickPassword')"
                            :type="passwordFieldType"
                            :append-icon="passwordIcon"
                            v-on:click:append="passwordVisibility"
                            required
                            color="orange lighten-2"
                            v-model="password"
                            :rules="rules.password"
                    ></v-text-field>
                </div>
                <div class="row-content mx-auto">
                    <v-text-field
                            name="email"
                            label="Email"
                            type="email"
                            required
                            color="orange lighten-2"
                            v-model="email"
                            :rules="rules.email"
                            :readonly="isReadOnly"
                    ></v-text-field>
                </div>
                <div class="d-flex justify-center py-4">
                    <v-btn
                            class="main--yellow white--text px-4"
                            :disabled="!valid"
                            elevation="0"
                            @click="sendData"
                    >
                        {{ $t('set') }}
                    </v-btn>
                </div>
            </v-form>
        </v-card>
    </div>
</template>

<script>
    import AuthService from '../../../app-front/services/api/AuthService';

    export default {
        name: "SetCredentials",
        data() {
            return {
                error: null,
                isPasswordVisible: false,
                password: null,
                email: null,
                userID: null,
                token: null,
                rules: {
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    password: [
                        v => !!v || this.$t('passwordRequired')
                    ]
                },
                valid: false
            }
        },
        computed: {
            isReadOnly() {
                return !!this.redirectCredentials.email;
            },
            redirectCredentials() {
                return window.authRedirectCredentials;
            },
            passwordIcon() {
                return this.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye';
            },
            passwordFieldType() {
                return this.isPasswordVisible ? 'text' : 'password';
            }
        },
        methods: {
            passwordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible
            },
            sendData() {
                const credentials = {
                    email: this.email,
                    password: this.password,
                    c_password: this.password,
                    token: this.token,
                    id: this.userID,
                };

                AuthService.setCredentials(credentials)
                    .then(res => {
                        if(res.data.error) {
                            this.error = res.data.error;

                            setTimeout(() => {
                                this.error = null;
                            }, 3000);
                        } else {
                            this.initLogin(res.data.success.token);
                            const path = this.$store.state.account.beforeLoginPath;
                            this.$store.commit('loginDialogHide');

                            if(path) {
                                this.$router.push(path);
                                this.$store.commit('updateBeforeLoginPath', null);
                            } else {
                                this.$router.push('/profile/personal-info');
                            }
                        }
                    })
                    .catch(err => {console.log(err)});
            },
            setInitial() {
                this.email = this.redirectCredentials.email;
                this.userID = this.redirectCredentials.id;
                this.token = this.redirectCredentials.token;
            }
        },
        created() {
            this.setInitial();
        }
    }
</script>

<style scoped>

</style>
